import { createStore } from 'redux';
import { ENV } from '../../libs/config';
import rootReducer from '../reducers/index';


const store = ENV == 'local' ? createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
) : createStore(rootReducer);

export default store;
